"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterSiblingClauses = exports.filterAudienceTargetingClauses = exports.filterSpecificTestModeClause = exports.filterTestModeClauses = exports.filterNonUrlTargetingClauses = undefined;
exports.filterUrlTargetingClauses = filterUrlTargetingClauses;

var _constants = require("./constants");

var filterNonUrlTargetingClauses = exports.filterNonUrlTargetingClauses = function filterNonUrlTargetingClauses(clause) {
  return clause.conditionName === _constants.conditionNames.DOMAINS || clause.conditionName === _constants.conditionNames.PROPERTIES || clause.conditionName === _constants.conditionNames.LANGUAGES || clause.conditionName === _constants.conditionNames.MOBILE_CONTENT || clause.conditionName === _constants.conditionNames.CONTENT || clause.conditionName === _constants.conditionNames.EVENT || clause.conditionName === _constants.conditionNames.SEGMENTS || clause.conditionName === _constants.conditionNames.FREQUENCY;
};

function filterUrlTargetingClauses(clause) {
  return clause.conditionName === _constants.conditionNames.URL;
}

var filterTestModeClauses = exports.filterTestModeClauses = function filterTestModeClauses(clause) {
  return clause.conditionName === _constants.conditionNames.PROPERTIES && clause.property === "_testContentId";
};

var filterSpecificTestModeClause = exports.filterSpecificTestModeClause = function filterSpecificTestModeClause(clause, testFlowId) {
  return clause.conditionName === _constants.conditionNames.PROPERTIES && clause.property === "_testContentId" && clause.value === testFlowId;
};

var filterAudienceTargetingClauses = exports.filterAudienceTargetingClauses = function filterAudienceTargetingClauses(clause) {
  return Object.values(_constants.propertyConditionNames).includes(clause.conditionName) && clause.property !== "_ABGroup" && clause.property !== "_testContentId";
};

var filterSiblingClauses = exports.filterSiblingClauses = function filterSiblingClauses(conditionName) {
  return function (clause) {
    return clause.conditionName === conditionName;
  };
};